import { fetcher } from "@website/fetcher/fetcher";
import {
  AuthRequestOtpBodyType,
  AuthRequestOtpResponseType
} from "@website/widget/login/services/auth-request-otp/auth-request-otp.types";

export const AuthRequestOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/request-otp`;
export const AuthRequestOtpByCallUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/request-audio-otp`;

export const AuthRequestOtpService = (
  body: AuthRequestOtpBodyType
): Promise<AuthRequestOtpResponseType> =>
  fetcher({
    url: AuthRequestOtpUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);

export const AuthRequestOtpByCallService = (
  body: AuthRequestOtpBodyType
): Promise<AuthRequestOtpResponseType> =>
  fetcher({
    url: AuthRequestOtpByCallUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
